import type { LegacyRef } from 'react';
import { forwardRef } from 'react';

import { WidgetProps } from '@highimpact-front/remote-widget-core';
import { DisplayerTypeEnum } from '@highimpact-frontend/displayer-types';

import {
  ApiDashboardElement,
  ApiReturnCampaign,
} from '@highimpact-frontend/api-types';

import ElementMeasureDisplayerWidget from './ElementMeasureDisplayerWidget';
import ElementTableDisplayerWidget from './ElementTableDisplayerWidget';
import { resolveRendererTypeFromElement } from './displayerElementConsistency';

interface DisplayerProps extends WidgetProps {
  displayer_id: number;
  elementData: ApiDashboardElement;
  dashboardElementId: number;
  gridId: number;
  mode?: 'line' | 'hist';
  campaigns: ApiReturnCampaign[];
}

function DisplayerWidget(
  props: DisplayerProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const rendererType = resolveRendererTypeFromElement(props.elementData);

  if (
    rendererType === DisplayerTypeEnum.table ||
    rendererType === DisplayerTypeEnum.tablebycampaign
  ) {
    return <ElementTableDisplayerWidget {...props} ref={ref} />;
  }

  return <ElementMeasureDisplayerWidget {...props} ref={ref} />;
}

export default forwardRef(DisplayerWidget);
